import React, { Component } from "react";
import {
  Form,
  Input,
  Container,
  Segment,
  Grid,
  Button
} from "semantic-ui-react";
import Link, { navigateTo } from "gatsby-link";
import { graphql, gql, compose } from "react-apollo";
import "./Login.css";

class LoginComponent extends Component {
  state = { email: "", password: "" };
  componentDidMount = () => {
    if (!this.props.loading && this.props.user) {
      navigateTo("/");
    }
  };
  componentDidUpdate = () => {
    if (!this.props.data.loading && this.props.data.user) {
      navigateTo("/");
    }
  };
  handleChange = (e, { name, value }) => this.setState({ [name]: value });

  handleSubmit = () => {
    const { email, password } = this.state;

    this.props
      .mutate({
        variables: {
          email: email,
          password: password
        }
      })
      .then(({ data }) => {
        localStorage.setItem("gToken", data.info.token);
        this.props.history.push("/booking");
      })
      .catch(err => console.error(err));
  };

  render() {
    console.log(this.props);
    const { password, email } = this.state;
    return (
      <div className="login-gradient">
        <Container style={{ paddingTop: "15vw", textAlign: "center" }}>
          <Segment raised style={{ maxWidth: "500px", margin: "0 auto" }}>
            <h1>
              Please login to view your scheduled cleans or schedule a new
              cleaning.
            </h1>
            <Form onSubmit={this.handleSubmit}>
              <Form.Input
                placeholder="Email"
                name="email"
                value={email}
                onChange={this.handleChange}
              />
              <Form.Input
                placeholder="Password"
                name="password"
                value={password}
                onChange={this.handleChange}
                type="password"
              />
              <Form.Button fluid content="Submit" />
              <Link to={"/booking"}>
                <Button fluid negative>
                  Cancel{" "}
                </Button>
              </Link>
            </Form>
          </Segment>
        </Container>
      </div>
    );
  }
}
const myMutation = gql`
  mutation Login($email: String!, $password: String!) {
    info: authenticateUser(email: $email, password: $password) {
      token
    }
  }
`;
const myQuery = gql`
  query loginQuery {
    user: loggedInUser {
      id
    }
  }
`;

export default compose(
  graphql(myQuery, {
    options: {
      fetchPolicy: "cache-and-network"
    }
  }),
  graphql(myMutation)
)(LoginComponent);



// WEBPACK FOOTER //
// ./src/components/Login/index.jsx